module.exports = __webpack_public_path__ + "img/avti_1.bfdd6816.png";